import React, { Component } from "react";

import { Card, Divider } from "../../components/globals";
import BookListItem from "../../components/BookListItem";

class BookList extends Component {
    render() {
        return (
            <Card>
                <ul aria-label="accordion">
                    {this.props.books.map((book, i) => {
                        return (
                            <li key={book.id}>
                                {i !== 0 ? <Divider /> : null}
                                <BookListItem book={book} />
                            </li>
                        );
                    })}
                </ul>
            </Card>
        );
    }
}

export default BookList;



// WEBPACK FOOTER //
// ./src/components/BookList/index.js